<template>
  <div class="f360-aviso-fila">
    <div class="content-left">
      <p>
        <b>Importante:</b>
        O tempo de processamento pode estar acima do normal. Estamos trabalhando
        para normalização o mais rápido possível.
      </p>
    </div>
    <div class="content-right"></div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
@use "@/styles/theme/f360-theme" as *;
@use "@/styles/variables" as *;

.f360-aviso-fila {
  font-family: $fontFamily;
  width: auto;
  height: 1.875rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem;
  // background-color: #f48181;
  background-color: #c1c1c1;
  // background-color: #f8ed78;
  border-radius: 0.3125rem;
  color: #070707;
  font-weight: 400;
  font-size: 14px;
  line-height: 32px;
  margin: 6px 0 0 0;

  .content-left {
    display: flex;
    align-items: center;
  }

  .content-right {
    display: flex;
    align-items: center;

    p {
      margin-right: 10px;
    }
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: auto;

    .content-left {
      display: flex;
      flex-direction: column;

      p {
        text-align: center;
      }
    }
  }
}
</style>
